/** CSS gradient → CanvasGradient */
/** 尝试将 CSS gradient 字符串解析为 CanvasGradient（支持 linear-gradient）*/
export function parseGradientToCanvasGradient(
  ctx: CanvasRenderingContext2D,
  cssGradient: string,
  width: number,
  height: number
): CanvasGradient | null {
  const linearMatch = cssGradient.match(/linear-gradient\((.+)\)/s);
  if (!linearMatch) return null;

  const parts = splitGradientParts(linearMatch[1]);
  if (parts.length < 2) return null;

  let angle = 180;
  let colorStops = parts;
  const angleMatch = parts[0].match(/^(-?\d+(?:\.\d+)?deg|to\s+\w+(\s+\w+)?)$/i);
  if (angleMatch) {
    const raw = parts[0].trim().toLowerCase();
    if (raw.startsWith('to ')) {
      const dir = raw.slice(3).trim();
      angle = { 'bottom': 180, 'top': 0, 'right': 90, 'left': 270, 'bottom right': 135, 'bottom left': 225, 'top right': 45, 'top left': 315 }[dir] ?? 180;
    } else {
      angle = parseFloat(raw);
    }
    colorStops = parts.slice(1);
  }

  const rad = (angle - 90) * (Math.PI / 180);
  const cx = width / 2, cy = height / 2;
  const len = Math.abs(width * Math.sin(rad)) + Math.abs(height * Math.cos(rad));
  const x0 = cx - Math.cos(rad) * len / 2, y0 = cy - Math.sin(rad) * len / 2;
  const x1 = cx + Math.cos(rad) * len / 2, y1 = cy + Math.sin(rad) * len / 2;
  const grad = ctx.createLinearGradient(x0, y0, x1, y1);

  colorStops.forEach((stop, i) => {
    const s = stop.trim();
    const posMatch = s.match(/^(.+?)\s+([\d.]+%|[\d.]+px)$/);
    const color = posMatch ? posMatch[1].trim() : s;
    const pos = posMatch ? (posMatch[2].endsWith('%') ? parseFloat(posMatch[2]) / 100 : parseFloat(posMatch[2]) / len) : i / (colorStops.length - 1);
    try { grad.addColorStop(Math.max(0, Math.min(1, pos)), color); } catch { /* invalid color, skip */ }
  });

  return grad;
}

export function splitGradientParts(s: string): string[] {
  const parts: string[] = [];
  let depth = 0, current = '';
  for (const ch of s) {
    if (ch === '(') depth++;
    else if (ch === ')') depth--;
    if (ch === ',' && depth === 0) { parts.push(current.trim()); current = ''; }
    else current += ch;
  }
  if (current.trim()) parts.push(current.trim());
  return parts;
}
